<script lang="ts">
  import type { NewsPost } from '@/components/appDriver/newsfeed/types'
  import {
    getNewsCategoryClasses,
    getNewsCategoryLabel,
    getNewsPriorityClasses,
    getNewsPriorityLabel,
  } from '@/components/appDriver/newsfeed/utils'

  export let post: NewsPost
</script>

<div class="flex flex-wrap items-center gap-2">
  {#if post.isPinned}
    <span class="inline-flex items-center gap-1 rounded-full bg-blue-primary/10 px-2.5 py-1 text-[11px] font-semibold tracking-wide text-blue-primary">
      <span class="h-1.5 w-1.5 rounded-full bg-blue-primary"></span>
      ປັກໝຸດ
    </span>
  {/if}

  <span class="inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold tracking-wide {getNewsCategoryClasses(post.category)}">
    {getNewsCategoryLabel(post.category)}
  </span>

  <span class="inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold tracking-wide {getNewsPriorityClasses(post.priority)}">
    {getNewsPriorityLabel(post.priority)}
  </span>
</div>
